<template>
    <div>
        <ValidationObserver ref="formModalValidate">
                <b-row>
                    <div class="col-12">
                        <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('name')">
                                <b-form-input :validate-error="errors[0]" v-model="form.name">
                                </b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="subject" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('subject')">
                                <b-form-input :validate-error="errors[0]" v-model="form.subject">
                                </b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="code" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('code')">
                                <b-form-input :validate-error="errors[0]" v-model="form.code">
                                </b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="recipients" rules="" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('recipients')">
                                <b-form-input :validate-error="errors[0]" v-model="form.recipients">
                                </b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="body" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('body')">
                                <CkEditor v-model="form.body"/>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>

                </b-row>
            </ValidationObserver>
            <div class="col-12 mt-3 d-flex">
                <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                    {{ $t("save").toUpperCase() }}
                </b-button>
            </div>
    </div>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import CkEditor from "@/components/interactive-fields/Ckeditor.vue";
    import EmailTemplateServices from "@/services/EmailTemplateServices";

    export default {
        components: {
            CkEditor,
            ValidationProvider, ValidationObserver,
        },
        data() {
            return {
                formLoading: false,
                form: {
                    recipients: null,
                    code: null,
                    name: null,
                    body: null,
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    EmailTemplateServices.store(this.form)
                                   .then((response) => {
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("createFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   });
                }
            }
        }
    }
</script>
